import React from "react";
import Footer from "../Footer";
import "./Footer3.css";

function Footer3(props) {
  const { footerProps } = props;

  return (
    <div className="footer-5">
      <Footer className={footerProps.className} />
    </div>
  );
}

export default Footer3;
